import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LinkedInSidebar from './LinkedInSidebar';
import axios from "axios";

const RatingsPage = ({ 
  currentPage,
  setCurrentPage,
  setTitleDescription,
  openCompanyPage
}) => {
  
  useEffect(() => {
    setTitleDescription("Fractofolio - Ratings", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);

  const [loading, setLoading] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [authStatus, setAuthStatus] = useState(null);

  const [totalPages, setTotalPages] = useState(20);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
  };

  // Function to handle Next button click
  const nextPage = () => {
    if (currentPageNumber < totalPages) {
      setCurrentPageNumber(currentPageNumber + 1);
    }
  };

  // Function to handle Previous button click
  const prevPage = () => {
    if (currentPageNumber > 1) {
      setCurrentPageNumber(currentPageNumber - 1);
    }
  };

  // Determine which page numbers to show (max 5 page numbers)
  const getPageNumbers = () => {
    const pageNumbers = [];
    const start = Math.max(currentPageNumber - 2, 1); // Start page number (current page - 2)
    const end = Math.min(start + 4, totalPages); // End page number (start + 4)

    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };




  const [text, setText] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchResults, setsearchResults] = useState([]);
  const canShowSearchRef = useRef(true);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [ratingResults, setRatingResults] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [industries, setIndustries] = useState([]);
  


  // Assuming you're inside a component
  const getRatingCompanies = useCallback(async() => {
    setLoading(true);
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/ratings/get-companies`, { page: currentPageNumber, sector: selectedSector, industry: selectedIndustry });
      if(response.data.status == 'ok') {
        // setRatingResults(response.data.result);

        setRatingResults(prev => {
          // Создаем мапу уже существующих id для быстрой проверки
          const existingIds = new Set(prev.map(item => item.id));

          // Фильтруем новые элементы, исключая те, id которых уже есть
          const filteredNewItems = response.data.result.filter(item => !existingIds.has(item.id));

          // Возвращаем объединенный массив без дубликатов
          return [...prev, ...filteredNewItems];
        });

        setTotalPages(response.data.max_page);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPageNumber, selectedIndustry, selectedSector]);

  const getSectors = useCallback(async() => {
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/ratings/get-sectors`, { });
      if(response.data.status == 'ok') {
        setSectors(response.data.sectors);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      // setLoadingSearch(false);
    }
  }, []);

  const getIndustries = useCallback(async() => {
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/ratings/get-industries`, { sector: selectedSector });
      if(response.data.status == 'ok') {
        setIndustries(response.data.industries);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      // setLoadingSearch(false);
    }
  }, [selectedSector]);

  useEffect(() => {
    getRatingCompanies();
    getSectors();
  }, [getRatingCompanies, getSectors]);

  useEffect(() => {
    getRatingCompanies();
    getIndustries();
  }, [currentPageNumber, selectedSector, selectedIndustry, getRatingCompanies, getIndustries]);

  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
          
          <div className="lg:col-span-3">
            <div className="linkedin-card mb-6">
              <div className="linkedin-card-header">
                <h2 className="text-xl font-bold text-gray-900">Company Rankings</h2>
                <p className="text-gray-600">Top performing companies ranked by success rate and market metrics</p>
              </div>
              
              <div className="linkedin-card-content">
                <div className="flex flex-col md:flex-row gap-4 mb-6">
                  <select 
                    value={selectedSector}
                    onChange={(event) => {setCurrentPageNumber(1); setSelectedSector(event.target.value); setIndustries([]); setSelectedIndustry(""); setRatingResults([]); }}
                    className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-linkedin-blue"
                  >
                    <option value="">All Sectors</option>
                    {sectors && sectors.map((item, key) => (
                      <option key={`key_sector_${key}`} value={item}>{item}</option>
                    ))}
                  </select>

                  {selectedSector != "" && industries.length > 0 && (
                    <select
                      value={selectedIndustry}
                      onChange={(event) => {setCurrentPageNumber(1); setSelectedIndustry(event.target.value); setRatingResults([]); }}
                      className="border p-2 rounded-md"
                    >
                      <option value="">All Industries</option>
                      {/* <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option> */}

                      {industries && industries.map((item, key) => (
                        <option key={`key_industry_${key}`} value={item}>{item}</option>
                      ))}
                      
                    </select>
                  )}
                  
                </div>
                
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                    {ratingResults.map((stock, index) => (
                      <div key={stock.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center justify-between">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                              <img src={stock.image} />
                            </div>
                            <div className="ml-3">
                              <h3 className="font-bold text-lg text-gray-900">{stock.company_name}</h3>
                              {/* <p className="text-sm text-gray-600">{stock.name}</p> */}
                            </div>
                          </div>
                        </div>
                        
                        <div className="space-y-2">
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">CIK:</span>
                            <span className="font-medium">{stock.cik}</span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Symbol:</span>
                            <span className="font-medium">{stock.symbol}</span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Sector:</span>
                            <span className="font-medium">{stock.sector}</span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Industry:</span>
                            <span className="font-medium">{stock.industry}</span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Success Rate:</span>
                            <span className={`font-medium ${
                              stock.success_rate >= 85 ? 'text-green-600' : 
                              stock.success_rate >= 70 ? 'text-yellow-600' : 'text-red-600'
                            }`}>
                              {stock.success_rate}%
                            </span>
                          </div>
                        </div>
                        
                        <button className="w-full mt-4 bg-linkedin-blue text-white py-2 px-4 rounded-lg hover:bg-linkedin-blue-dark transition-colors" onClick={() => openCompanyPage(stock)}>
                          View Details
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <div className='mt-2 mx-auto w-fit'>
                  <button onClick={() => {setCurrentPageNumber(currentPageNumber+1)}} className="linkedin-action-btn" disabled={loading}>
                    {loading === false && (
                      <span>Load more companies</span>
                    )}
                    {loading === true && (
                      <span>Loading...</span>
                    )}
                  </button>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingsPage;